import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './../static/images/logo_2_lines.svg'

class Header extends React.Component {
  render = () => {
    let showStep = null
    switch (this.props.step) {
      case 1:
        showStep = (
          <span className='steps'>
            <span className='step'>1</span> → 2 → 3
          </span>
        )
        break

      case 2:
        showStep = (
          <span className='steps'>
            1 → <span className='step'>2</span> → 3
          </span>
        )
        break

      case 3:
        showStep = (
          <span className='steps'>
            1 → 2 → <span className='step'>3</span>
          </span>
        )
        break
    }

    let genericError = ''
    if (this.props.errors && this.props.errors.generic !== '') {
      genericError = <div id='error_message'>{this.props.errors.generic}</div>
    }

    let subtitle = null
    if (this.props.subtitle) {
      subtitle = (
        <div
          className={
            'section_title ' +
            (this.props.step >= 1 && this.props.step <= 3 ? 'has_steps' : '')
          }
        >
          {this.props.subtitle}
          <span className='tab' />
          {showStep}
        </div>
      )
    }

    return (
      <header>
        <Link to='/' title={this.props.polyglot.t('header.logo.title')}>
          <img id='logo' src={Logo} />
        </Link>
        {subtitle}
        {genericError}
      </header>
    )
  }
}

export default Header
